import { render, staticRenderFns } from "./DateCalendarIcon.vue?vue&type=template&id=4184173b&scoped=true&"
import script from "./DateCalendarIcon.vue?vue&type=script&lang=ts&"
export * from "./DateCalendarIcon.vue?vue&type=script&lang=ts&"
import style0 from "./DateCalendarIcon.vue?vue&type=style&index=0&id=4184173b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4184173b",
  null
  
)

/* custom blocks */
import block0 from "./DateCalendarIcon.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports